import { useSelector } from "react-redux";
import HorizantalBar from "../../../components/horizantalBar/HorizantalBar";
import PageLink from "../../../components/pageLink/PageLink";
import { allowedTabs } from "../../../constants/permissionCatalog";
import TournamentsCommentsNavigator from "../../../navigation/TournamentsCommentsNavigator";
import styles from "./tournamentComments.module.css";

const TournamentsComments = () => {
  const { rolePermissions } = useSelector((state) => state.user);
  const tabs = allowedTabs("tournament-comments", rolePermissions);

  return (
    <div className={styles.container}>
      <HorizantalBar>
        <div className={styles.linksWrapper}>
          {tabs.map((tab) => (
            <div key={tab.id} className={styles.linkWrapper}>
              <PageLink destination={`/dashboard/tournaments-comments/${tab.path}`}>{tab.label}</PageLink>
            </div>
          ))}
        </div>
      </HorizantalBar>
      <TournamentsCommentsNavigator />
    </div>
  );
};

export default TournamentsComments;
